import { TextSelection } from '../../composables/processTextSelection'
import { ActionTree, GetterTree, MutationTree } from 'vuex'

type SelectionPart = {
  startIndex: number
  endIndex: number
  speaker: string
}
class State {
  selection: TextSelection | null = null
  popupShown = false
  part: SelectionPart | null = null
}

const getters = {
  range(state: State): Range | null {
    return state.selection ? state.selection.range : null
  },
  boundaries(state: State): DOMRect | null {
    return state.selection ? state.selection.rangeBoundaries : null
  },
  popupShown(state: State): boolean {
    return state.popupShown
  },
  part(state: State): SelectionPart | null {
    return state.part
  }
} as GetterTree<State, any>

const mutations = {
  SET_SELECTION(state, selection: TextSelection | null) {
    state.selection = selection
  },
  SET_PART(state, part: SelectionPart | null) {
    state.part = part
  },
  TOGGLE_POPUP(state, value?: boolean) {
    if (value !== undefined) {
      state.popupShown = value
    } else {
      state.popupShown = !state.popupShown
    }
  }
} as MutationTree<State>

const actions = {
  setSelection(context, selection: TextSelection | null) {
    context.commit('SET_SELECTION', selection)
    context.commit('SET_PART', { speaker: selection.speaker })
  },
  setPart(context, part: SelectionPart | null) {
    context.commit('SET_PART', part)
  },
  clearSelection(context, hidePopup?: boolean) {
    context.commit('SET_SELECTION', null)
    context.commit('SET_PART', null)
    if (hidePopup) {
      context.commit('TOGGLE_POPUP', false)
    }
  },
  togglePopup(context, value?: boolean) {
    context.commit('TOGGLE_POPUP', value)
  }
} as ActionTree<State, any>

export default {
  namespaced: true,
  state: new State(),
  getters,
  mutations,
  actions
}
